import { render } from "./EditingSlidePreview.vue?vue&type=template&id=4b2c5b98&scoped=true"
import script from "./EditingSlidePreview.vue?vue&type=script&lang=js"
export * from "./EditingSlidePreview.vue?vue&type=script&lang=js"

import "./EditingSlidePreview.vue?vue&type=style&index=0&id=4b2c5b98&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2c5b98"]])

export default __exports__